import { cacheKeys } from "@constants/cache-keys";
import { useQuery } from "@tanstack/react-query";
import { flattenSessionItems } from "../helpers/session";
import { useSession } from "./useSession";

type Props = {
	sessionId: number | string;
	isSummativeTest: boolean;
	enabled?: boolean;
};

export const useSessionItems = ({
	sessionId,
	isSummativeTest,
	enabled = true,
}: Props) => {
	const { resumeSession } = useSession();
	return useQuery({
		queryKey: [cacheKeys.sessionItems, sessionId.toString()],
		queryFn: async () => {
			const response = await resumeSession({
				sessionId: Number(sessionId),
			});
			const flattenedSessionItems = flattenSessionItems(
				response.sessionItems,
				isSummativeTest,
			);
			return flattenedSessionItems.flat();
		},
		enabled,
	});
};
